var _g, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pdf",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.744,
    height: 82.443,
    viewBox: "0 0 78.744 82.443",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544",
    transform: "translate(9.598 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_54",
    "data-name": "Subtraction 54",
    d: "M60.9,82.443H8.244A8.254,8.254,0,0,1,0,74.2V70.414H43.943a5.006,5.006,0,0,0,5-5V37.629a5.006,5.006,0,0,0-5-5H0V8.244A8.253,8.253,0,0,1,8.244,0H47.87L69.145,21.275V74.2A8.254,8.254,0,0,1,60.9,82.443ZM31.339,16.313A3.864,3.864,0,1,0,35.2,20.178,3.869,3.869,0,0,0,31.339,16.313Zm-9.446,0a3.864,3.864,0,1,0,3.864,3.865A3.869,3.869,0,0,0,21.893,16.313Zm-9.446,0a3.864,3.864,0,1,0,3.865,3.865A3.869,3.869,0,0,0,12.447,16.313ZM45.225,5.351V23.988h18.6Z",
    transform: "translate(0 0)",
    fill: "#d6d6d6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_2",
    "data-name": "Exclusion 2",
    d: "M47.558,28.346H5a5.006,5.006,0,0,1-5-5V5A5.006,5.006,0,0,1,5,0H47.558a5.005,5.005,0,0,1,5,5V23.346A5.005,5.005,0,0,1,47.558,28.346ZM36.085,5.916V22.967h4.09V16.175h6.6V13.012h-6.6V9.089h7.259V5.916Zm-15.426,0V22.967H26.24a7.865,7.865,0,0,0,3.991-1.06A7.244,7.244,0,0,0,33,19a8.864,8.864,0,0,0,.985-4.2v-.785a8.8,8.8,0,0,0-1.02-4.186,7.212,7.212,0,0,0-2.8-2.893,8.048,8.048,0,0,0-4.044-1.025Zm-15.531,0V22.967h4.09V17.182h2.61A7.378,7.378,0,0,0,16.7,15.689,4.964,4.964,0,0,0,18.481,11.7a5.65,5.65,0,0,0-.822-3.016A5.436,5.436,0,0,0,15.34,6.636a7.893,7.893,0,0,0-3.443-.72ZM26.17,19.805H24.749V9.089h1.374a3.245,3.245,0,0,1,2.75,1.254,6.171,6.171,0,0,1,.943,3.724V14.8a6.226,6.226,0,0,1-.943,3.742A3.192,3.192,0,0,1,26.17,19.805ZM11.9,14.008H9.218V9.089h2.726a2.276,2.276,0,0,1,1.748.726,2.762,2.762,0,0,1,.641,1.909,2.236,2.236,0,0,1-.624,1.687A2.53,2.53,0,0,1,11.9,14.008Z",
    transform: "translate(0 37.553)",
    fill: "#d84e4e"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.844856e960d23bac229de466362602bb.svg";
export { ForwardRef as ReactComponent };